"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.J2534Interface = void 0;
var J2534Interface_js_1 = require("./J2534Interface.js");
Object.defineProperty(exports, "J2534Interface", { enumerable: true, get: function () { return J2534Interface_js_1.J2534Interface; } });
//# sourceMappingURL=index.js.map